import { useQuery } from '@apollo/client';
import { Select } from 'antd';
import { GET_DRIVERS } from 'Util/queries';
const { Option } = Select;

function DriversDropDown({ onChange, form, value, ...rest }) {

    const { data, loading } = useQuery(GET_DRIVERS, {
        variables: {
            where: {
                deleted_at: { _is_null: true },
                active: { _eq: true }
            }
        },
    });

    const list = data?.drivers ?? [];

    const handleChange = (v) => {
        const selected = list.find(item => item.id === v);
        if (form && selected) {
            form.setFieldsValue({
                driver_id: selected.id,
                driver_uuid: selected.uuid,
                driver_name: selected.name,
                driver_username: selected.username,
            });
        }
        if (onChange) onChange(v);
    };

    return (
        <Select
            {...rest}
            value={value}
            loading={loading}
            placeholder="Select a driver"
            onChange={handleChange}
        >
            {list.map(v => <Option value={v.id} key={`drivers-dd-opt${v.id}`}>{v.name}</Option>)}
        </Select>
    )
}

export default DriversDropDown
